import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_accessories: FaireCategoryEntity = {
  token: "cat_accessories",
  type: "category",
  name: "Accessories",
  level: 1,
  href: "/category/accessories",
  childCategoryTokens: [
    "cat_accessories-all",
    "cat_accessories-new-products",
    "cat_accessories-new-brands",
    "cat_accessories-bestsellers",
    "cat_accessories-bags",
    "cat_accessories-hats",
  ],
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
